import { useQueryClient } from '@tanstack/react-query'
import flagsmith from 'flagsmith'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router'

import { COOKIES_KEYS } from '../constants/cookiesKeys'
import { ROUTES } from '../constants/routes'

export function useSignOut() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const signOut = async () => {
    await queryClient.cancelQueries()
    await flagsmith.logout()
    sessionStorage.setItem('isSigningOut', 'true')

    Cookies.remove(COOKIES_KEYS.token)

    navigate(ROUTES.LOGIN.SIGN_IN, {
      replace: true,
    })

    setTimeout(() => {
      sessionStorage.removeItem('isSigningOut')
      queryClient.clear()
    }, 100)
  }

  return { signOut }
}
